module.exports = __webpack_public_path__ + "static/media/wj.07127b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wj.png
// module id = 688
// module chunks = 0 1